import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const PHONE = "0333 880 0363";
export const PHONE_TEL = "+443338800363";
export const EMAIL = "info@freedomdebtadvice.co.uk";
export const WHATSAPP = "447565207482";

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("fda_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const LEAD_STATUSES = ["NEW", "CALLING", "NO_ANSWER", "CALLBACK_REQUESTED", "CONTACTED",
  "PROSPECT", "REFERRED", "SALE", "NOT_INTERESTED", "UNANSWERED", "DUPLICATE", "DO_NOT_CONTACT", "CLOSED"];
export const PRIORITIES = ["HIGH", "MEDIUM", "STANDARD"];
export const CALL_OUTCOMES = ["No answer", "Connected", "Callback requested", "Not interested",
  "Wrong number", "Do not contact", "Prospect", "Other"];

export function whatsappUrl(number, text) {
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}

export function leadWhatsappMessage(lead) {
  return [
    "Hi Freedom Debt Advice,",
    "",
    "I have completed the debt assessment on your website and would like to discuss my situation.",
    "",
    `Lead Reference: ${lead.lead_reference}`,
    `Name: ${lead.first_name} ${lead.last_name}`,
    `Phone: ${lead.phone}`,
    `Email: ${lead.email}`,
    `Debt range: ${lead.debt_range}`,
    `Number of debts: ${lead.creditor_count}`,
    `Debt types: ${(lead.debt_types || []).join(", ")}`,
    `Payment status: ${lead.payment_status}`,
    `Preferred contact time: ${lead.preferred_contact_time}`,
    "",
    "Please contact me regarding my enquiry.",
  ].join("\n");
}
